import { Box, Typography } from '@mui/material'
import React from 'react'

type NoAccessBoxProps = {
  message?: string
}

export const NoDataToDisplayCard: React.FC<NoAccessBoxProps> = ({
  message,
}: NoAccessBoxProps) => {
  return (
    <Box
      display='grid'
      height='100%'
      alignItems='center'
      justifyContent='center'
      role='no-data-to-display'
    >
      <Typography variant='body2'>{message || 'No data to display'}</Typography>
    </Box>
  )
}
